import Common from '../../common/CommonNctv';
import YTplayer from '../../common/YTplayer';

class MovieItem {
    constructor(_data, _idx, _con){
        this.data = _data;
        this.idx = _idx;
        this.con = _con;
        this.com = Common.instance;
        this.data.iframeId = `video_ifame_${this.data.youtubeId}_${this.data.id}`;
    }

    addEvents(){}

    templ(){
        return `
        <li class="item">
            <a href="/view?tv=${this.com.ip}&id=${this.data.id}&from=popular" class="item-link">
                <div class="player-vod">
                    <img src="${this.data.thumbnail}"  style="display: block;position: absolute;width: 100%;height: 100%;top: 0;left: 0;" />
                    <div class="vod-embed vod_${this.data.id}" data-ncid="${this.data.id}">
                        <div class="vod-embed-inner">
                            <div id="${this.data.iframeId}"></div>
                        </div>
                    </div>
                </div>
                <img src="${this.data.thumbnail}" width="100%" />
            </a>
        </li>`;
    }

    init(){
        this.moviePlayer = new YTplayer({
            el_sel: `.main-movie-centertype`,
            el_id: this.data.iframeId,
            videoId: this.data.youtubeId,
            width: '100%', height: '100%',
            playerVars: {
                mute: true,
                start: this.data.startSeconds,
                autoplay: 0,
            }
        });

        $(`.vod-embed.vod_${this.data.id}`).hide();
    }

    play(){
        if (window.innerWidth < 960) return false;
        $(`.vod-embed.vod_${this.data.id}`).show();
        this.moviePlayer.play();
        this.timerGo();
    }
    
    stop(){
        clearTimeout(this.timer);
        this.timer = null;
        $(`.vod-embed.vod_${this.data.id}`).hide();
        this.moviePlayer.pause();
        this.moviePlayer.time = this.data.startSeconds;
    }
    
    timerGo(){
        // console.log( '??', this.idx, this.moviePlayer.time );
        this.timer = setTimeout(() => {
            if(this.data.endSeconds <= this.moviePlayer.time){
                this.stop();
                $(this.con).trigger({type: 'ITEM_PLAY_END', idx: this.idx});
            }else{
                this.timerGo();
            }
        }, 30);
    }
    
} // end of class
export default MovieItem;